import { getBuildEnvironment } from 'utils/environment';
import { formatNumber } from 'utils';

export const isSsr = typeof window === 'undefined';

export const LOCAL_STORAGE_KEY = 'first-point';
export const SESSION_STORAGE_KEY = 'session-point';
export const REFERRER_STORAGE_KEY = 'referrer';
export const ADS_STORAGE_KEY = 'ads';
export const VISITOR_ID_STORAGE_KEY = 'anst_id';
export const PREVIOUS_VISITOR_ID_STORAGE_KEY = 'previous_anst_id';
export const VISITOR_ID_PARAM = 'anst_id';
export const ADS_TOUCHES_LIMIT = 20;
export const AD_PAGES_PREFIX = '/lp';
export const DOMAIN_URL = (() => {
  switch (getBuildEnvironment()) {
    case 'staging':
      return 'https://stage.andersenlab.com';
    case 'development':
      return 'https://dev.andersenlab.com';
    case 'feature':
      return 'https://feature.andersenlab.com';
    case 'production':
    default:
      return 'https://andersenlab.com';
  }
})();

export const DOMAIN_URL_UK = (() => {
  switch (getBuildEnvironment()) {
    case 'staging':
      return 'https://stage.andersenlab.co.uk';
    case 'development':
      return 'https://dev.andersenlab.co.uk';
    case 'feature':
      return 'https://feature.andersenlab.co.uk';
    case 'production':
    default:
      return 'https://andersenlab.co.uk';
  }
})();

export const DOMAIN_URL_DE = (() => {
  switch (getBuildEnvironment()) {
    case 'staging':
      return 'https://stage.andersenlab.de';
    case 'development':
      return 'https://dev.andersenlab.de';
    case 'feature':
      return 'https://feature.andersenlab.de';
    case 'production':
    default:
      return 'https://andersenlab.de';
  }
})();

export const DOMAIN_URL_AE = (() => {
  switch (getBuildEnvironment()) {
    case 'staging':
      return 'https://stage.andersenlab.ae';
    case 'development':
      return 'https://dev.andersenlab.ae';
    case 'feature':
      return 'https://feature.andersenlab.ae';
    case 'production':
    default:
      return 'https://andersenlab.ae';
  }
})();

export const DOMAIN_URL_AZ = (() => {
  switch (getBuildEnvironment()) {
    case 'staging':
      return 'https://stage.andersenlab.az';
    case 'development':
      return 'https://dev.andersenlab.az';
    case 'feature':
      return 'https://feature.andersenlab.az';
    case 'production':
    default:
      return 'https://andersenlab.az';
  }
})();

export const DOMAIN_URL_KZ = (() => {
  switch (getBuildEnvironment()) {
    case 'staging':
      return 'https://stage.andersenlab.kz';
    case 'development':
      return 'https://dev.andersenlab.kz';
    case 'feature':
      return 'https://feature.andersenlab.kz';
    case 'production':
    default:
      return 'https://andersenlab.kz';
  }
})();

export const DOMAIN_URL_PL = (() => {
  switch (getBuildEnvironment()) {
    case 'staging':
      return 'https://stage.andersenlab.pl';
    case 'development':
      return 'https://dev.andersenlab.pl';
    case 'feature':
      return 'https://feature.andersenlab.pl';
    case 'production':
    default:
      return 'https://andersenlab.pl';
  }
})();

export const DOMAIN_URL_FR = (() => {
  switch (getBuildEnvironment()) {
    case 'staging':
      return 'https://stage.andersenlab.fr';
    case 'development':
      return 'https://dev.andersenlab.fr';
    case 'production':
    default:
      return 'https://andersenlab.fr';
  }
})();

export const DOMAIN_URL_NL = (() => {
  switch (getBuildEnvironment()) {
    case 'staging':
      return 'https://stage.andersenlab.nl';
    case 'development':
      return 'https://dev.andersenlab.nl';
    case 'production':
    default:
      return 'https://andersenlab.nl';
  }
})();

export const locales = [
  {
    hrefLang: 'x-default',
    domain: DOMAIN_URL,
  },
  {
    hrefLang: 'en',
    domain: DOMAIN_URL,
  },
  {
    hrefLang: 'en-us',
    domain: DOMAIN_URL,
  },
  {
    hrefLang: 'en-gb',
    domain: DOMAIN_URL_UK,
  },
  {
    hrefLang: 'de',
    domain: DOMAIN_URL_DE,
  },
  {
    hrefLang: 'ar',
    domain: DOMAIN_URL_AE,
  },
  {
    hrefLang: 'az',
    domain: DOMAIN_URL_AZ,
  },
  {
    hrefLang: 'fr',
    domain: DOMAIN_URL_FR,
  },
];

const employeeNumber = 3500;
const projectsNumber = 2000;

export const EMPLOYEES_COUNT = `${formatNumber(employeeNumber)}+`;
export const PROJECTS_COUNT = `${formatNumber(projectsNumber)}+`;

export const WHATSAPP_LINK = 'https://wa.me/message/W3YNZJUDFAVQJ1';
export const HEADER_DEVICE_TYPE_BREAKPOINT = 960;

export const TRACKING_DOMAINS = [
  DOMAIN_URL,
  DOMAIN_URL_UK,
  DOMAIN_URL_DE,
  DOMAIN_URL_AE,
  DOMAIN_URL_AZ,
  DOMAIN_URL_KZ,
  DOMAIN_URL_PL,
  DOMAIN_URL_FR,
  DOMAIN_URL_NL,
].map(url => new URL(url).hostname);
